module.exports = __webpack_public_path__ + "static/img/5.c48c538.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/5/3/zh/5.png
// module id = pmSN
// module chunks = 0